import { ReactNode } from 'react';
import { TableCellStyled } from './TableCell.styles';

interface Props {
  children: ReactNode | string | number;
  truncateText?: boolean;
  maxWidth?: string;
  width?: string;
  showOverflow?: boolean;
  checkboxMargin?: boolean;
}

export const TableCell = ({
  showOverflow,
  truncateText,
  maxWidth,
  width,
  children,
  ...props
}: Props) => (
  <TableCellStyled
    {...props}
    $showOverflow={showOverflow}
    $width={width}
    $maxWidth={maxWidth}
    $truncateText={truncateText}
    title={
      ['string', 'number'].includes(typeof children)
        ? String(children)
        : undefined
    }
  >
    {children}
  </TableCellStyled>
);
